import { render, staticRenderFns } from "./StatPicker.vue?vue&type=template&id=4935a056&scoped=true&"
import script from "./StatPicker.vue?vue&type=script&lang=ts&"
export * from "./StatPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4935a056",
  null
  
)

export default component.exports